<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <b-list-group>
          <b-list-group-item
            class="flex-column align-items-start"
            v-for="configuration in configurations"
            :key="configuration.id"
          >
            <div class="d-flex w-100 justify-content-between">
              <h5 class="mb-1 text-secundary">
                {{ configuration.title }}
              </h5>
            </div>
            <b-card-text class="mb-1" v-if="configuration.type === 'sino'">
              <b-button
                class="btn-block btn-primary"
                @click="toggleSiNo(configuration)"
              >
                {{ configuration.value | capitalize }}
              </b-button>
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'correomultiple'">
              <input class="form-control" v-model="configuration.value">
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'opciones'">
              <select type="select" class="form-control" v-model="configuration.value">
                <option
                  v-for="option in configuration.extra.opciones"
                  :value="option.valor"
                  :key="option.valor"
                >
                  {{ option.descripcion }}
                </option>
              </select>
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'usuarios'">
              <ListUser
                class="w-100 mb-0"
                autocomplete
                label=""
                name="user"
                v-model="configuration.value"
                data-vv-as="usuario"
                v-validate="'required'"
              />
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'perfiles'">
              <ListProfiles
                class="w-100 mb-0"
                autocomplete
                label=""
                name="perfiles"
                v-model="configuration.value"
                data-vv-as="perfil"
                v-validate="'required'"
              />
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'opcionesaprobaciones'">
              <ListAprovals
                class="w-100 mb-0"
                autocomplete
                label=""
                name="apronvals"
                :reference="reference"
                v-model="configuration.value"
                data-vv-as="usuario"
                v-validate="'required'"
              />
            </b-card-text>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'textomail'">
              <b-form-textarea v-model="configuration.value"></b-form-textarea>
            </b-card-text>
            <div class="mb-1" v-else-if="configuration.type === 'pasosejecucion'">
              <div class="row">
                <div class="col-12 col-md-3">
                  <b-form-group label="Tipo de paso">
                    <select
                      class="form-control"
                      id="stepType"
                      name="stepType"
                      v-model="configuration.stepType"
                      v-validate="'required'"
                    >
                      <option
                        :value="stepTypesCodes.USER"
                      >Usuario
                      </option>
                      <option
                        :value="stepTypesCodes.GROUP"
                      >Grupo
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-4" v-if="configuration.stepType === stepTypesCodes.GROUP">
                  <list-groups
                    autocomplete
                    label="Grupo del responsable"
                    name="groupStep"
                    ref="groupStep"
                    :typeList="configuration.stepType"
                    v-model="configuration.groupStep"
                    :danger="errors.has('steps.groupStep')"
                    :danger-text="errors.first('steps.groupStep')"
                    v-validate="{ required: configuration.stepType === stepTypesCodes.GROUP }"
                  />
                </div>
                <div class="col-12 col-md-4" v-if="configuration.stepType != stepTypesCodes.GROUP">
                  <list-user
                    autocomplete
                    label="Usuario"
                    name="userStep"
                    v-model="configuration.userStep"
                    ref="userStep"
                    :danger="errors.has('steps.userStep')"
                    :danger-text="errors.first('steps.userStep')"
                    v-validate="{ required: configuration.stepType === stepTypesCodes.USER }"
                  />
                </div>
                <div class="col-12 col-md-3">
                  <b-form-group label="Tipo de paso">
                    <select
                      class="form-control"
                      id="stepType"
                      name="stepType"
                      v-model="configuration.rolType"
                      v-validate="'required'"
                    >
                      <option
                        :value="rolTypesCodes.APPROVER"
                      >
                        Aprobador
                      </option>
                      <option
                        :value="rolTypesCodes.REVIEWER"
                      >
                        Revisor
                      </option>
                      <option
                        :value="rolTypesCodes.SIGNER"
                      >
                        Firmante
                      </option>
                    </select>
                  </b-form-group>
                </div>
                <div class="col-12 col-md-2 d-flex mt-8">
                  <b-form-group>
                    <vs-button
                      color="primary"
                      icon="add"
                      v-on:click="addStep(configuration)"
                    >
                    </vs-button>
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div
                  class="col-12 col-md-4"
                  v-for="(step, index) in configuration.value"
                  :key="'step-'+index"
                >
                  <div class="step-wrapper">
                    <span class="step-number">{{ index + 1 }}</span>
                    <span v-if="!readonly" class="step-delete">
                      <vs-icon
                        icon="highlight_off"
                        size="small"
                        bg="white"
                        color="danger"
                        round
                        @click="removeStep(configuration, index)"
                      />
                    </span>
                    <div class="cursor-default text-center step-name">
                      {{ step.nombre }}
                    </div>
                    <div class="step-types">
                      <span
                        class="bg-secondary badges"
                        v-if="+step.tipoPasoId === stepTypesCodes.USER"
                      >
                        Usuario
                      </span>
                      <span
                        class="blue badges"
                        v-if="+step.tipoPasoId === stepTypesCodes.GROUP"
                      > Grupo </span>
                    </div>
                    <div class="step-roles">
                      <span
                        class="bg-info badges" v-if="+step.rolId === rolTypesCodes.APPROVER"
                      >
                        Aprobador
                      </span>
                      <span
                        class="bg-success badges"
                        v-if="+step.rolId === rolTypesCodes.SIGNER"
                      >
                        Firmante
                      </span>
                      <span
                        class="bg-warning badges"
                        v-if="+step.rolId === rolTypesCodes.REVIEWER"
                      >
                        Revisor
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <b-card-text class="mb-1" v-else-if="configuration.type === 'info'">
              {{configuration.value}}
            </b-card-text>
            <b-card-text class="mb-1" v-else>
              No soportado el tipo : <strong>{{ configuration.type }}</strong>
            </b-card-text>
          </b-list-group-item>
        </b-list-group>
        <div class="error-message mt-3 text-danger text-right">
          <span>
            {{errorConsequence}}
          </span>
        </div>
      </div>
    </div>
    <div class="row text-center">
      <div class="col-12 col-md-6">
        <button class="mt-3 btn btn-danger" block @click="$emit('close')">Cancelar</button>
      </div>
      <div class="col-12 col-md-6">
        <button class="mt-3 btn btn-primary" block @click="configurar">Configurar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { BListGroup, BListGroupItem } from 'bootstrap-vue';
import { mapGetters } from 'vuex';

import AprovalMixin from './AprovalMixin';

import StepTypes, { CAN_REPEAT_TYPES } from '@/febos/chile/dnt/mixins/StepTypes';
import RolTypes from '@/febos/chile/dnt/mixins/RolTypes';
import {
  rolTypes,
  stepTypes
} from '@/febos/chile/approvals/components/trays/managementTray/constants';
import Base64Mixin from '@/febos/global/_vue/mixins/Base64Mixin';
import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import ListAprovals from '@/febos/chile/lists/components/ListAprovals';
import ListProfiles from '@/febos/chile/lists/components/ListProfiles';

export default {
  name: 'ConsequencesModal',
  props: ['consequence', 'processconfig', 'reference', 'readonly'],
  mixins: [Base64Mixin, AprovalMixin],
  components: {
    BListGroup, BListGroupItem, ListUser, ListAprovals, ListGroups, ListProfiles
  },
  data() {
    return {
      errorConsequence: '',
      rolTypes,
      stepTypes,
      stepTypesCodes: StepTypes,
      rolTypesCodes: RolTypes,
      extra: {},
      configurations: []
    };
  },
  mounted() {
    this.initConsequence();
  },
  computed: {
    ...mapGetters('List', ['usersState', 'groupsState', 'profilesState'])
  },
  methods: {
    notify(message) {
      this.$vs.notify({
        title: 'Oops!',
        text: message,
        color: 'danger',
        time: 5000,
        position: 'top-center'
      });
    },
    initConsequence() {
      this.extra = JSON.parse(this.processconfig.extra || '{}');
      this.configureConsequence(
        this.consequence,
        this.extra.configuracion,
        (configuration, key, valor) => {
          const finalConfig = configuration;
          finalConfig.extra = valor;
          this.configurations.push(finalConfig);
        }
      );
    },
    toggleSiNo(configuration) {
      const mutableConfig = configuration;
      mutableConfig.value = configuration.value === 'si' ? 'no' : 'si';
    },
    validarConfig(config, plantilla) {
      this.errorConsequence = '';
      for (const key in config) {
        if (config[key] == null || config[key] == '') {
          if (plantilla && plantilla[key].opcional == true) {
            continue;
          }
          this.errorConsequence = 'Vaya! Tienes que completar todos los campos';
        }
      }

      return this.errorConsequence == '';
    },
    configurar() {
      const stepsFind = this.configurations.find((config) => config.type === 'pasosejecucion');
      if (stepsFind) {
        const steps = stepsFind.value;
        if (steps && steps.length > 1 && steps.slice(-1)[0].rolId === this.rolTypesCodes.REVIEWER) {
          this.notify('El último paso no puede ser rol revisor');
          return;
        }
      }

      this.configurationsObject = this.configurations.reduce((index, option) => ({
        ...index,
        [option.id]: option
      }), {});

      const newConfiguration = {};
      this.configurations.forEach((config) => {
        newConfiguration[config.id] = config.value;
        return config;
      });
      if (!this.validarConfig(newConfiguration, this.configurationsObject)) {
        return;
      }
      this.$emit('configurate', this.encode(JSON.stringify(newConfiguration)));
    },
    findDuplicatedSteps(item, stepIndex) {
      const steps = item.value;
      let duplicated = false;
      const prevStep = steps[stepIndex - 1];
      const prevStepId = `${prevStep?.responsableId}${prevStep?.rolId}${prevStep?.tipoPasoId}`;
      const nextStep = steps[stepIndex + 1];
      const nextStepId = `${nextStep?.responsableId}${nextStep?.rolId}${nextStep?.tipoPasoId}`;
      if (steps.length > 1 && prevStepId === nextStepId) {
        duplicated = true;
      }
      return duplicated;
    },
    removeStep(item, index) {
      const duplicated = this.findDuplicatedSteps(item, index);
      if (duplicated) {
        this.notify('No puedes eliminar un paso que deje dos pasos iguales juntos');
        return;
      }
      const itemfinal = item;
      itemfinal.value.splice(index, 1);
    },
    addStep(config) {
      const configuration = config;
      if (
        !configuration.stepType
        || (!configuration.userStep && !configuration.groupStep)
        || !configuration.rolType
      ) {
        this.notify('Falta seleccionar algo');
        return;
      }
      let name = '';
      let id = '';
      if (configuration.stepType === this.stepTypesCodes.USER) {
        const user = this.usersState.value.find((opt) => opt.value === configuration.userStep);
        name = user.label;
        id = configuration.userStep;
      } else {
        const group = this.groupsState.list.find(
          (option) => option.value === configuration.groupStep
        );
        name = group.label;
        id = configuration.groupStep;
      }

      const step = {
        tipoPasoId: configuration.stepType,
        responsableId: id,
        rolId: configuration.rolType,
        nombre: name,
      };
      const previousStep = configuration.value[configuration.value.length - 1];
      const canRepeat = !!CAN_REPEAT_TYPES.includes(previousStep?.tipoPasoId);
      if (
        (previousStep && !canRepeat)
        && previousStep.responsableId === step.responsableId
        && +previousStep.tipoPasoId === +step.tipoPasoId
        && +previousStep.rolId === +step.rolId
      ) {
        this.notify('No pueden haber dos pasos iguales de forma continua');
        return;
      }
      if (configuration.value === '') configuration.value = [];
      configuration.value.push(step);
    }
  }
};
</script>

<style scoped lang="scss">
@import "steps";
</style>
